import { useCallback } from 'react';

export const useInitCommunication = () => {
    return useCallback(async () => {
        return {};
    }, []);
};
